module.exports = __webpack_public_path__ + "static/tablet-phone--5a360ee625830dcf0fca390fd7984898.png";